module.exports = __webpack_public_path__ + "static/media/YB5M15_4.766c576d.jpg";